/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 766:
/***/ ((__unused_webpack_module, exports) => {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = true;
var EventHandler = /** @class */ (function () {
    function EventHandler() {
        this.events = [];
    }
    EventHandler.prototype.register = function (el, event, listener) {
        if (!el || !event || !listener)
            return null;
        this.events.push({ el: el, event: event, listener: listener });
        el.addEventListener(event, listener);
        return { el: el, event: event, listener: listener };
    };
    EventHandler.prototype.unregister = function (_a) {
        var el = _a.el, event = _a.event, listener = _a.listener;
        if (!el || !event || !listener)
            return null;
        this.events = this.events.filter(function (e) { return el !== e.el
            || event !== e.event || listener !== e.listener; });
        el.removeEventListener(event, listener);
        return { el: el, event: event, listener: listener };
    };
    EventHandler.prototype.unregisterAll = function () {
        this.events.forEach(function (_a) {
            var el = _a.el, event = _a.event, listener = _a.listener;
            return el.removeEventListener(event, listener);
        });
        this.events = [];
    };
    return EventHandler;
}());
exports.Z = EventHandler;


/***/ }),

/***/ 722:
/***/ (() => {

class VariantSelection extends HTMLElement {
  static get observedAttributes() {
    return ['variant'];
  }

  constructor() {
    super();
    this._loaded = false;
    this._productFetcher = Promise.resolve(false);

    this._onMainElChange = event => {
      this.variant = event.currentTarget.value;
    };

    const mainInputEl = this.querySelector('input[data-variants]');
    this._mainEl = mainInputEl || this.querySelector('select[data-variants]');
  }

  set variant(value) {
    if (value) {
      this.setAttribute('variant', value);
    } else {
      this.removeAttribute('variant');
    }
  }

  get variant() {
    return this.getAttribute('variant');
  }

  connectedCallback() {
    this._productFetcher = this._fetchProduct();
    const mainInputEl = this.querySelector('input[data-variants]');
    this._mainEl = mainInputEl || this.querySelector('select[data-variants]');

    this._mainEl.addEventListener('change', this._onMainElChange);

    this.variant = this._mainEl.value;
  }

  disconnectedCallback() {
    this._mainEl.removeEventListener('change', this._onMainElChange);

    this._mainEl = null;
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue === newValue) return;

    switch (name) {
      case 'variant':
        this._changeVariant(newValue);

        break;
    }
  }

  getProduct() {
    return this._loaded ? Promise.resolve(this._product) : this._productFetcher;
  }

  getVariant() {
    return this.getProduct().then(product => product ? product.variants.find(v => v.id.toString() === this.variant) || false : false).catch(() => false);
  }

  getState() {
    return this.getVariant().then(variant => variant ? 'selected' : this.getAttribute('variant'));
  }

  _changeVariant(value) {
    this._dispatchEvent(value).then(() => {
      this._mainEl.value = value;
    });
  }

  _fetchProduct() {
    return fetch(this.getAttribute('product-url')).then(response => response.json()).then(product => {
      this._product = product;
      return product;
    }).catch(() => {
      this._product = null;
    }).finally(() => {
      this._loaded = true;
    });
  }

  _dispatchEvent(value) {
    return this.getProduct().then(product => {
      const variant = product ? product.variants.find(v => v.id.toString() === value) || false : false;
      const state = variant ? 'selected' : value;
      const event = new CustomEvent('variant-change', {
        detail: {
          product,
          variant,
          state
        }
      });
      this.dispatchEvent(event);
    });
  }

}

const valueElementType = {
  select: 'option',
  radio: 'input[type="radio"]'
};

function setSelectedOptions(selectOptions, radioOptions, selectedOptions) {
  selectOptions.forEach(({
    option
  }) => {
    option.value = selectedOptions[parseInt(option.dataset.variantOptionIndex, 10)];
  });
  radioOptions.forEach(({
    values
  }) => {
    values.forEach(value => {
      value.checked = value.value === selectedOptions[parseInt(value.dataset.variantOptionValueIndex, 10)];
    });
  });
}

function getOptions(optionsEls) {
  const select = [];
  const radio = [];

  for (let i = 0; i < optionsEls.length; i++) {
    const optionEl = optionsEls[i];
    const wrappers = optionEl.matches('[data-variant-option-value-wrapper]') ? [optionEl] : Array.prototype.slice.call(optionEl.querySelectorAll('[data-variant-option-value-wrapper]'));
    const values = optionEl.matches('[data-variant-option-value]') ? [optionEl] : Array.prototype.slice.call(optionEl.querySelectorAll('[data-variant-option-value]'));
    if (!values.length) break;
    const option = {
      option: optionEl,
      wrappers,
      values
    };

    if (values[0].matches(valueElementType.select)) {
      select.push(option);
    } else if (values[0].matches(valueElementType.radio)) {
      radio.push(option);
    }
  }

  return {
    select,
    radio
  };
}

function getSelectedOptions(product, selectOptions, radioOptions) {
  const options = product.options.map(() => 'not-selected');
  selectOptions.forEach(({
    option
  }) => {
    if (option.value !== 'not-selected') {
      options[parseInt(option.dataset.variantOptionIndex, 10)] = option.value;
    }
  });
  radioOptions.forEach(({
    values
  }) => {
    values.forEach(value => {
      if (value.checked) {
        options[parseInt(value.dataset.variantOptionValueIndex, 10)] = value.value;
      }
    });
  });
  return options;
}

function getVariantFromSelectedOptions(variants, selectedOptions) {
  for (let i = 0; i < variants.length; i++) {
    const variant = variants[i];
    const isVariant = variant.options.every((option, index) => option === selectedOptions[index]);
    if (isVariant) return variant; // We found the variant
  }

  return false;
}

function _getVariant(variants, options) {
  return variants.find(variant => variant.options.every((option, index) => option === options[index]));
}

function _setOptionsMap(product, selectedOptions, optionsMap, option1, option2 = null, option3 = null) {
  const updatedOptionsMap = { ...optionsMap
  };
  const options = [option1, option2, option3].filter(option => !!option);

  const variant = _getVariant(product.variants, options);

  const variantOptionMatches = options.filter((option, index) => option === selectedOptions[index]).length;
  const isCurrentVariant = variantOptionMatches === product.options.length;
  const isNeighbor = variantOptionMatches === product.options.length - 1;

  for (let i = 0; i < options.length; i++) {
    const option = options[i];

    if (option) {
      let {
        setByCurrentVariant,
        setByNeighbor,
        accessible,
        available
      } = optionsMap[i][option];

      if (variant) {
        accessible = variant.available || accessible; // The current variant is always
        // the priority for option availability

        if (isCurrentVariant) {
          setByCurrentVariant = true;
          ({
            available
          } = variant);
        } else if (!setByCurrentVariant && isNeighbor) {
          // If the variant is a neighbor
          // And the option doesn't belong to the variant
          // Use its availability information for the option
          // If multiple neighbors exist, prefer true
          available = setByNeighbor ? available || variant.available : variant.available;
          setByNeighbor = true;
        }
      } else if (isCurrentVariant) {
        // Catch case where current variant doesn't exist
        // Ensure availability is false
        setByCurrentVariant = true;
        available = false;
      } else if (!setByCurrentVariant && isNeighbor) {
        // Catch case where neighbor doesn't exist
        // Ensure availability is false
        // If multiple neighbors exist, prefer true
        available = setByNeighbor ? available : false;
        setByNeighbor = true;
      } // If the option isn't set by either
      // the current variant or a neighbor
      // default to general accessibility


      if (!setByCurrentVariant && !setByNeighbor) {
        available = accessible;
      }

      updatedOptionsMap[i][option] = {
        setByCurrentVariant,
        setByNeighbor,
        accessible,
        available
      };
    }
  }

  return updatedOptionsMap;
}

function getOptionsAccessibility(product, selectedOptions) {
  let optionsMap = product.options.map(() => ({}));

  for (let i = 0; i < product.options.length; i++) {
    for (let j = 0; j < product.variants.length; j++) {
      const variant = product.variants[j];
      const option = variant.options[i];
      optionsMap[i][option] = {
        setByCurrentVariant: false,
        setByNeighbor: false,
        accessible: false,
        available: false
      };
    }
  }

  const option1Values = optionsMap.length >= 1 ? Object.keys(optionsMap[0]) : [];
  const option2Values = optionsMap.length >= 2 ? Object.keys(optionsMap[1]) : [];
  const option3Values = optionsMap.length >= 3 ? Object.keys(optionsMap[2]) : [];
  option1Values.forEach(option1Value => {
    option2Values.forEach(option2Value => {
      option3Values.forEach(option3Value => {
        optionsMap = _setOptionsMap(product, selectedOptions, optionsMap, option1Value, option2Value, option3Value);
      });

      if (!option3Values.length) {
        optionsMap = _setOptionsMap(product, selectedOptions, optionsMap, option1Value, option2Value);
      }
    });

    if (!option2Values.length) {
      optionsMap = _setOptionsMap(product, selectedOptions, optionsMap, option1Value);
    }
  });
  return optionsMap;
}

function updateOptions(product, selectOptions, radioOptions, selectedOptions, disableUnavailableOptions, removeUnavailableOptions) {
  const options = [...selectOptions, ...radioOptions];

  if (options.length === 0) {
    return;
  }

  const optionsAccessibility = getOptionsAccessibility(product, selectedOptions); // Iterate over each option type

  for (let i = 0; i < product.options.length; i++) {
    // Corresponding select dropdown, if it exists
    const optionValues = options.find(({
      option
    }) => {
      if (parseInt(option.dataset.variantOptionIndex, 10) === i) {
        return true;
      }

      return false;
    });

    if (optionValues) {
      const fragment = document.createDocumentFragment();
      const {
        option,
        wrappers,
        values
      } = optionValues;

      for (let j = values.length - 1; j >= 0; j--) {
        const wrapper = wrappers[j];
        const optionValue = values[j];
        const {
          value
        } = optionValue;
        const {
          available
        } = value in optionsAccessibility[i] ? optionsAccessibility[i][value] : false;
        const {
          accessible
        } = value in optionsAccessibility[i] ? optionsAccessibility[i][value] : false;
        const isChooseOption = value === 'not-selected'; // Option element to indicate unchosen option
        // Disable unavailable options

        optionValue.disabled = isChooseOption || disableUnavailableOptions && !accessible;
        optionValue.dataset.variantOptionAccessible = accessible;
        optionValue.dataset.variantOptionAvailable = available;

        if (!removeUnavailableOptions || accessible || isChooseOption) {
          fragment.insertBefore(wrapper, fragment.firstElementChild);
        }
      }

      option.innerHTML = '';
      option.appendChild(fragment);
      const chosenValue = values.find(value => value.selected || value.checked);
      option.dataset.variantOptionChosenValue = chosenValue && chosenValue.value !== 'not-selected' ? chosenValue.value : false;
    }
  }
}

class OptionsSelection extends HTMLElement {
  static get observedAttributes() {
    return ['variant-selection', 'disable-unavailable', 'remove-unavailable'];
  }

  static synchronize(mainOptionsSelection) {
    const mainVariantSelection = mainOptionsSelection.getVariantSelection(); // Fast return if we aren't associated with a variant selection

    if (!mainVariantSelection) return Promise.resolve(false);
    return mainOptionsSelection.getSelectedOptions().then(selectedOptions => {
      // Update all other options selects associated with the same variant ui
      const optionsSelections = document.querySelectorAll('options-selection');
      optionsSelections.forEach(optionsSelection => {
        if (optionsSelection !== mainOptionsSelection && optionsSelection.getVariantSelection() === mainVariantSelection) {
          optionsSelection.setSelectedOptions(selectedOptions);
        }
      });
    }).then(() => true);
  }

  constructor() {
    super();
    this.style.display = '';
    this._events = [];
    this._onChangeFn = this._onOptionChange.bind(this);
    this._optionsEls = this.querySelectorAll('[data-variant-option]');
    ({
      select: this._selectOptions,
      radio: this._radioOptions
    } = getOptions(this._optionsEls));

    this._associateVariantSelection(this.getAttribute('variant-selection'));
  }

  set variantSelection(value) {
    if (value) {
      this.setAttribute('variant-selection', value);
    } else {
      this.removeAttribute('variant-selection');
    }
  }

  get variantSelection() {
    return this.getAttribute('variant-selection');
  }

  connectedCallback() {
    this._optionsEls = this.querySelectorAll('[data-variant-option]');
    ({
      select: this._selectOptions,
      radio: this._radioOptions
    } = getOptions(this._optionsEls));

    this._associateVariantSelection(this.getAttribute('variant-selection'));

    this._selectOptions.forEach(({
      option
    }) => {
      option.addEventListener('change', this._onChangeFn);

      this._events.push({
        el: option,
        fn: this._onChangeFn
      });
    });

    this._radioOptions.forEach(({
      values
    }) => {
      values.forEach(value => {
        value.addEventListener('change', this._onChangeFn);

        this._events.push({
          el: value,
          fn: this._onChangeFn
        });
      });
    });

    this._onOptionChange();
  }

  disconnectedCallback() {
    this._resetOptions();

    this._events.forEach(({
      el,
      fn
    }) => el.removeEventListener('change', fn));

    this._events = [];
  }

  attributeChangedCallback(name, _oldValue, newValue) {
    switch (name) {
      case 'variant-selection':
        this._associateVariantSelection(newValue);

        break;

      case 'disable-unavailable':
      case 'remove-unavailable':
        this._updateOptions(this.hasAttribute('disable-unavailable'), this.hasAttribute('remove-unavailable'));

        break;
    }
  }

  getSelectedOptions() {
    if (!this._variantSelection) return Promise.resolve(null);
    return this._variantSelection.getProduct().then(product => {
      if (!product) return null;
      return getSelectedOptions(product, this._selectOptions, this._radioOptions);
    });
  }

  getVariantSelection() {
    return this._variantSelection;
  }

  setSelectedOptions(selectedOptions) {
    setSelectedOptions(this._selectOptions, this._radioOptions, selectedOptions);
    return this._updateOptions(this.hasAttribute('disable-unavailable'), this.hasAttribute('remove-unavailable'), selectedOptions);
  }

  _associateVariantSelection(id) {
    this._variantSelection = id ? document.getElementById(id) : this.closest('variant-selection');
  }

  _updateLabels() {
    // Update any labels
    for (let i = 0; i < this._optionsEls.length; i++) {
      const optionsEl = this._optionsEls[i];
      let optionsNameEl = null;
      let {
        parentElement
      } = optionsEl;

      while (parentElement && !optionsNameEl) {
        const tmpOptionsNameEl = parentElement.querySelector('[data-variant-option-name]');

        if (tmpOptionsNameEl) {
          optionsNameEl = tmpOptionsNameEl;
        }

        ({
          parentElement
        } = parentElement);
      }

      if (optionsNameEl) {
        optionsNameEl.dataset.variantOptionChosenValue = optionsEl.dataset.variantOptionChosenValue;

        if (optionsEl.dataset.variantOptionChosenValue !== 'false') {
          optionsNameEl.innerHTML = optionsNameEl.dataset.variantOptionName;
          const optionNameValueSpan = optionsNameEl.querySelector('span');

          if (optionNameValueSpan) {
            optionNameValueSpan.innerHTML = optionsEl.dataset.variantOptionChosenValue;
          }
        } else {
          optionsNameEl.innerHTML = optionsNameEl.dataset.variantOptionChooseName;
        }
      }
    }
  }

  _resetOptions() {
    return this._updateOptions(false, false);
  }

  _updateOptions(disableUnavailableOptions, removeUnavailableOptions, selectedOptions = null) {
    if (!this._variantSelection) return Promise.resolve(false);
    return this._variantSelection.getProduct().then(product => {
      updateOptions(product, this._selectOptions, this._radioOptions, selectedOptions || getSelectedOptions(product, this._selectOptions, this._radioOptions), disableUnavailableOptions, removeUnavailableOptions);

      this._updateLabels();
    }).then(() => true);
  }

  _updateVariantSelection(product, selectedOptions) {
    if (!this._variantSelection) return;
    const variant = getVariantFromSelectedOptions(product.variants, selectedOptions);
    const isNotSelected = selectedOptions.some(option => option === 'not-selected'); // Update master select

    if (variant) {
      this._variantSelection.variant = variant.id;
    } else {
      this._variantSelection.variant = isNotSelected ? 'not-selected' : 'unavailable';
    }
  }

  _onOptionChange() {
    if (!this._variantSelection) return;

    this._variantSelection.getProduct().then(product => {
      if (!product) return;
      const selectedOptions = getSelectedOptions(product, this._selectOptions, this._radioOptions);

      this._updateOptions(this.hasAttribute('disable-unavailable'), this.hasAttribute('remove-unavailable'), selectedOptions);

      this._updateVariantSelection(product, selectedOptions);

      OptionsSelection.synchronize(this);
    });
  }

}

if (!customElements.get('variant-selection')) {
  customElements.define('variant-selection', VariantSelection);
}

if (!customElements.get('options-selection')) {
  customElements.define('options-selection', OptionsSelection);
}


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";

// EXTERNAL MODULE: ./node_modules/@pixelunion/shopify-variants-ui/dist/index.es.js
var index_es = __webpack_require__(722);
;// CONCATENATED MODULE: ./node_modules/@shopify/theme-addresses/theme-addresses.js
/**
 * CountryProvinceSelector Constructor
 * @param {String} countryOptions the country options in html string
 */
function CountryProvinceSelector(countryOptions) {
  if (typeof countryOptions !== 'string') {
    throw new TypeError(countryOptions + ' is not a string.');
  }
  this.countryOptions = countryOptions;
}

/**
 * Builds the country and province selector with the given node element
 * @param {Node} countryNodeElement The <select> element for country
 * @param {Node} provinceNodeElement The <select> element for province
 * @param {Object} options Additional settings available
 * @param {CountryProvinceSelector~onCountryChange} options.onCountryChange callback after a country `change` event
 * @param {CountryProvinceSelector~onProvinceChange} options.onProvinceChange callback after a province `change` event
 */
CountryProvinceSelector.prototype.build = function (countryNodeElement, provinceNodeElement, options) {
  if (typeof countryNodeElement !== 'object') {
    throw new TypeError(countryNodeElement + ' is not a object.');
  }

  if (typeof provinceNodeElement !== 'object') {
    throw new TypeError(provinceNodeElement + ' is not a object.');
  }

  var defaultValue = countryNodeElement.getAttribute('data-default');
  options = options || {}

  countryNodeElement.innerHTML = this.countryOptions;
  countryNodeElement.value = defaultValue;

  if (defaultValue && getOption(countryNodeElement, defaultValue)) {
    var provinces = buildProvince(countryNodeElement, provinceNodeElement, defaultValue);
    options.onCountryChange && options.onCountryChange(provinces, provinceNodeElement, countryNodeElement);
  }

  // Listen for value change on the country select
  countryNodeElement.addEventListener('change', function (event) {
    var target = event.target;
    var selectedValue = target.value;
    
    var provinces = buildProvince(target, provinceNodeElement, selectedValue);
    options.onCountryChange && options.onCountryChange(provinces, provinceNodeElement, countryNodeElement);
  });

  options.onProvinceChange && provinceNodeElement.addEventListener('change', options.onProvinceChange);
}

/**
 * This callback is called after a user interacted with a country `<select>`
 * @callback CountryProvinceSelector~onCountryChange
 * @param {array} provinces the parsed provinces
 * @param {Node} provinceNodeElement province `<select>` element
 * @param {Node} countryNodeElement country `<select>` element
 */

 /**
 * This callback is called after a user interacted with a province `<select>`
 * @callback CountryProvinceSelector~onProvinceChange
 * @param {Event} event the province selector `change` event object
 */

/**
 * Returns the <option> with the specified value from the
 * given node element
 * A null is returned if no such <option> is found
 */
function getOption(nodeElement, value) {
  return nodeElement.querySelector('option[value="' + value +'"]')
}

/**
 * Builds the options for province selector
 */
function buildOptions (provinceNodeElement, provinces) {
  var defaultValue = provinceNodeElement.getAttribute('data-default');

  provinces.forEach(function (option) {
    var optionElement = document.createElement('option');
    optionElement.value = option[0];
    optionElement.textContent = option[1];

    provinceNodeElement.appendChild(optionElement);
  })

  if (defaultValue && getOption(provinceNodeElement, defaultValue)) {
    provinceNodeElement.value = defaultValue;
  }
}

/**
 * Builds the province selector
 */
function buildProvince (countryNodeElement, provinceNodeElement, selectedValue) {
  var selectedOption = getOption(countryNodeElement, selectedValue);
  var provinces = JSON.parse(selectedOption.getAttribute('data-provinces'));

  provinceNodeElement.options.length = 0;

  if (provinces.length) {
    buildOptions(provinceNodeElement, provinces)
  }

  return provinces;
}

// EXTERNAL MODULE: ./node_modules/@pixelunion/events/dist/EventHandler.js
var EventHandler = __webpack_require__(766);
;// CONCATENATED MODULE: ./source/scripts/utilities/ShippingCalculator.js



class ShippingCalculator {
  constructor({ el }) {
    this.el = el;
    this.events = new EventHandler/* default */.Z();
    this.rates = this.el.querySelector('[data-shipping-rates]');
    this.message = this.el.querySelector('[data-shipping-message]');
    this.zip = this.el.querySelector('[data-shipping-calculator-zipcode]');
    this.submit = this.el.querySelector('.get-rates');
    this.response = this.el.querySelector('[data-shipping-calculator-response]');
    this.countrySelect = this.el.querySelector('[data-shipping-calculator-country]');
    this.provinceSelect = this.el.querySelector('[data-shipping-calculator-province]');
    this.provinceContainer = this.el.querySelector('[data-shipping-calculator-province-container]');

    this.buildCalculator();
  }

  buildCalculator() {
    this.shippingCountryProvinceSelector = new CountryProvinceSelector(this.countrySelect.innerHTML);
    this.shippingCountryProvinceSelector
      .build(
        this.countrySelect,
        this.provinceSelect,
        {
          onCountryChange: provinces => {
            if (provinces.length) {
              this.provinceContainer.style.display = 'block';
            } else {
              this.provinceContainer.style.display = 'none';
            }

            // "Province", "State", "Region", etc. and "Postal Code", "ZIP Code", etc.
            // Even countries without provinces include a label.
            const { label, zip_label: zipLabel } = window.Countries[this.countrySelect.value];
            this.provinceContainer.querySelector('label[for="address_province"]').innerHTML = label;
            this.el.querySelector('label[for="address_zip"]').innerHTML = zipLabel;
          },
        },
      );

    this.events.register(this.submit, 'click', e => {
      e.preventDefault();
      this.getRates();
    });
  }

  getRates() {
    const shippingAddress = {};
    shippingAddress.country = this.countrySelect ? this.countrySelect.value : '';
    shippingAddress.province = this.provinceSelect ? this.provinceSelect.value : '';
    shippingAddress.zip = this.zip ? this.zip.value : '';

    const queryString = Object.keys(shippingAddress)
      .map(key => `${encodeURIComponent(`shipping_address[${key}]`)}=${encodeURIComponent(shippingAddress[key])}`)
      .join('&');

    fetch(`${window.PXUTheme.routes.cart_url}/shipping_rates.json?${queryString}`)
      .then(response => response.json())
      .then(data => this.displayRates(data));
  }

  displayRates(rates) {
    const propertyName = Object.keys(rates);
    this.clearRates();

    if (propertyName[0] === 'shipping_rates') {
      rates.shipping_rates.forEach(rate => {
        const rateLi = document.createElement('li');
        rateLi.innerHTML = `${rate.name}: ${this.formatPrice(rate.price)}`;
        this.rates.appendChild(rateLi);
      });

      if (rates.shipping_rates.length > 1) {
        this.message.innerHTML = `${window.PXUTheme.translation.additional_rates_part_1} ${rates.shipping_rates.length} ${window.PXUTheme.translation.additional_rates_part_2} ${this.zip.value}, ${this.provinceSelect.value}, ${this.countrySelect.value}, ${window.PXUTheme.translation.additional_rates_part_3} ${this.formatPrice(rates.shipping_rates[0].price)}`;
      } else {
        this.message.innerHTML = `${window.PXUTheme.translation.additional_rate} ${this.zip.value}, ${this.provinceSelect.value}, ${this.countrySelect.value}, ${window.PXUTheme.translation.additional_rate_at} ${this.formatPrice(rates.shipping_rates[0].price)}`;
      }

      this.response.classList.add('shipping-rates--display-rates');
    } else {
      this.message.innerHTML = `Error: ${propertyName[0]} ${rates[propertyName[0]]}`;
      this.response.classList.add('shipping-rates--display-error');
    }
  }

  clearRates() {
    this.response.classList.remove('shipping-rates--display-error', 'shipping-rates--display-rates');
    this.message.innerHTML = '';
    this.rates.innerHTML = '';
  }

  formatPrice(price) {
    let formattedPrice;

    if (window.PXUTheme.currency.display_format === 'money_with_currency_format') {
      formattedPrice = `<span class="money">${window.PXUTheme.currency.symbol}${price} ${window.PXUTheme.currency.iso_code}</span>`;
    } else {
      formattedPrice = `<span class="money">${window.PXUTheme.currency.symbol}${price}</span>`;
    }

    return formattedPrice;
  }

  unload() {
    this.events.unregisterAll();
  }
}

;// CONCATENATED MODULE: ./source/scripts/app.js



// Section Shopify window.PXUTheme.theme editor events

$(document)
.on('shopify:section:reorder', function(e){

  var $target = $(e.target);
  var $parentSection = $('#shopify-section-' + e.detail.sectionId);

  if (window.PXUTheme.jsHeader.enable_overlay == true) {
    window.PXUTheme.jsHeader.unload();
    window.PXUTheme.jsHeader.updateOverlayStyle(window.PXUTheme.jsHeader.sectionUnderlayIsImage());
  }

});

$(document)
.on('shopify:section:load', function(e){

  // Shopify section as jQuery object
  var $section = $(e.target);

  // Vanilla js selection of Shopify section
  var section = document.getElementById('shopify-section-' + e.detail.sectionId);

  // Blocks within section
  var $jsSectionBlocks = $section.find('.shopify-section[class*=js]');

  var sectionObjectUrl = $section.find('[data-theme-editor-load-script]').attr('src');

  // Check classes on schema and look for js (eg. jsMap)
  for (var i = 0; i < section.classList.length; i++) {
    if (section.classList[i].substring(0, 2) === "js"){
      var triggerClass = section.classList[i];

      // Check to see if section script exists
      if (typeof window.PXUTheme[triggerClass] == 'undefined') {
        // make AJAX call to load script
        window.PXUTheme.loadScript(triggerClass, sectionObjectUrl, function () {
          window.PXUTheme[triggerClass].init($(section));
        });
      } else {
        if (window.PXUTheme[triggerClass]) {
          // console.log('Section: ' + triggerClass + ' has been loaded.')
          window.PXUTheme[triggerClass].init($(section));
        } else {
          // console.warn('Uh oh, ' + triggerClass + ' is referenced in section schema class, but can not be found. Make sure "z__' + triggerClass + '.js" and window.PXUTheme.' + triggerClass + '.init() function exists.');
        }
      }
    }
  }

  // Check classes on block element and look for js (eg. jsMap)
  if ($jsSectionBlocks.length > 0) {
    var $jsSectionBlockNames = $jsSectionBlocks.each(function () {
      for (var i = 0; i < this.classList.length; i++) {
        if (this.classList[i].substring(0, 2) === "js") {
          var triggerClass = this.classList[i];
          var $block = $('.'+ triggerClass)
          var blockUrl = $block.find('[data-theme-editor-load-script]').attr('src');

          // Check to see if section script exists
          if (typeof window.PXUTheme[triggerClass] == 'undefined') {
            // make AJAX call to load script
            window.PXUTheme.loadScript(triggerClass, blockUrl, function () {
              window.PXUTheme[triggerClass].init($block);
            });
          } else {
            if (window.PXUTheme[triggerClass]) {
              // console.log('Block: ' + triggerClass + ' has been loaded.')
              window.PXUTheme[triggerClass].init($(this));
            } else {
              // console.warn('Uh oh, ' + triggerClass + ' is referenced in block class, but can not be found. Make sure "z__' + triggerClass + '.js" and window.PXUTheme.' + triggerClass + '.init() function exists.');
            }
          }

        }
      }
    });
  }

  // Load video feature
  window.PXUTheme.video.init();

  // Scrolling animations
  window.PXUTheme.animation.init();

  // Initialize reviews
  window.PXUTheme.productReviews.init();

  // Object Fit Images
  window.PXUTheme.objectFitImages.init();

  // Infinite scrolling
  window.PXUTheme.infiniteScroll.init();

  // Disclosure menus
  window.PXUTheme.disclosure.enable();

  // Search
  $(document).on('click',  '[data-show-search-trigger]', function(){
    window.PXUTheme.jsHeader.showSearch();
  });

  $('.search-overlay__close').on('click', function(){
    window.PXUTheme.jsHeader.hideSearch();
  });

  if (window.PXUTheme.theme_settings.enable_autocomplete == true) {
    window.PXUTheme.predictiveSearch.init();
  }
  // Product review scroll
  window.PXUTheme.productReviews.productReviewScroll();

});


$(document)
.on('shopify:section:unload', function(e){

  // Shopify section as jQuery object
  var $section = $(e.target);

  // Vanilla js selection of Shopify section
  var section = document.getElementById('shopify-section-' + e.detail.sectionId);

  // Blocks within section
  var $jsSectionBlocks = $section.find('.shopify-section[class*=js]');

  // Check classes on schema and look for js (eg. jsMap)
  for (var i = 0; i < section.classList.length; i++) {
    if (section.classList[i].substring(0, 2) === "js"){
      var triggerClass = section.classList[i];
      if (window.PXUTheme[triggerClass]) {
        // console.log('Section: ' + triggerClass + ' is unloaded.')
        window.PXUTheme[triggerClass].unload($(section));
      } else {
        // console.warn('Uh oh, ' + triggerClass + ' is referenced in section schema class, but can not be found. Make sure "z__' + triggerClass + '.js" and window.PXUTheme.' + triggerClass + '.unload() function exists.');
      }
    }
  }

  // Check classes on block element and look for js (eg. jsMap)
  if ($jsSectionBlocks.length > 0) {
    var $jsSectionBlockNames = $jsSectionBlocks.each(function () {
      for (var i = 0; i < this.classList.length; i++) {
        if (this.classList[i].substring(0, 2) === "js") {
          var triggerClass = this.classList[i];
          if (window.PXUTheme[triggerClass]) {
            // console.log('Block: ' + triggerClass + ' is unloaded.')
            window.PXUTheme[triggerClass].unload($(this));
          } else {
            // console.warn('Uh oh, ' + triggerClass + ' is referenced in block class, but can not be found. Make sure "z__' + triggerClass + '.js" and window.PXUTheme.' + triggerClass + '.unload() function exists.');
          }

        }
      }
    });
  }

  // Scrolling animations
  window.PXUTheme.animation.unload($section);

  // QuantityBox
  window.PXUTheme.quantityBox.unload($section);

  // Infinite scrolling
  window.PXUTheme.infiniteScroll.unload($section);

  // Disclosure menus
  window.PXUTheme.disclosure.enable();

});

$(document)
.on('shopify:section:select', function(e){

  // Shopify section as jQuery object
  var $section = $(e.target);

  // Vanilla js selection of Shopify section
  var section = document.getElementById('shopify-section-' + e.detail.sectionId);

  // Force show state when section is selected in theme editor
  for (var i = 0; i < section.classList.length; i++) {
    if (section.classList[i].substring(0, 2) === "js") {
      var triggerClass = section.classList[i];
      if (window.PXUTheme[triggerClass].showThemeEditorState) {
        window.PXUTheme[triggerClass].showThemeEditorState(e.detail.sectionId, $section);
      }
    }
  }

  // Predictive search
  if (window.PXUTheme.theme_settings.enable_autocomplete == true) {
    window.PXUTheme.predictiveSearch.init();
  }

  if($('.tabs').length > 0) {
    window.PXUTheme.tabs.enableTabs();
  }

  if(isScreenSizeLarge() && window.PXUTheme.jsHeader.enable_overlay === true) {
    window.PXUTheme.jsHeader.updateOverlayStyle(window.PXUTheme.jsHeader.sectionUnderlayIsImage());
  }

  if ($('.block__recommended-products').length > 0) {
    var $productPage = $('.block__recommended-products').parents('.product-page');
    window.PXUTheme.jsRecommendedProducts.init($productPage);
  }

});

$(document)
.on('shopify:section:deselect', function(e){

  // Shopify section as jQuery object
  var $section = $(e.target);

  // Vanilla js selection of Shopify section
  var section = document.getElementById('shopify-section-' + e.detail.sectionId);

  // Force hide state when section is selected in theme editor
  for (var i = 0; i < section.classList.length; i++) {
    if (section.classList[i].substring(0, 2) === "js") {
      var triggerClass = section.classList[i];
      if (window.PXUTheme[triggerClass].showThemeEditorState) {
        window.PXUTheme[triggerClass].hideThemeEditorState(e.detail.sectionId, $(section));
      }
    }
  }

});

// Block Shopify window.PXUTheme.theme editor events

$(document)
.on('shopify:block:select', function(e){

  var blockId = e.detail.blockId;
  var $parentSection = $('#shopify-section-' + e.detail.sectionId);
  var $block = $('#shopify-section-' + blockId);

  if($('.jsFeaturedPromos').length > 0) {
    window.PXUTheme.jsFeaturedPromos.blockSelect($parentSection, blockId);
  }

  if($('.jsSlideshowWithText').length > 0) {
    window.PXUTheme.jsSlideshowWithText.blockSelect($parentSection, blockId);
  }

  if ($('.jsSlideshowClassic').length > 0) {
    window.PXUTheme.jsSlideshowClassic.blockSelect($parentSection, blockId);
  }

  if($('.jsTestimonials').length > 0) {
    window.PXUTheme.jsTestimonials.blockSelect($parentSection, blockId);
  }

  // Sidebar collection multi-tag filter
  if ($block.hasClass('sidebar__block')) {
    var $toggleBtn = $block.find('[data-sidebar-block__toggle="closed"]');
    if ($toggleBtn) {
      window.PXUTheme.jsSidebar.openSidebarBlock($toggleBtn);
    }
  }

  // Predictive search
  if (window.PXUTheme.theme_settings.enable_autocomplete == true) {
    window.PXUTheme.predictiveSearch.init();
  }

  // Scrolling animations
  window.PXUTheme.animation.init();

  // Object Fit Images
  window.PXUTheme.objectFitImages.init();

});

$(document)
.on('shopify:block:deselect', function(e){

  var $block = $('#shopify-section-' + e.detail.blockId);

  if ($block.hasClass('sidebar__block')) {
    var $toggleBtn = $block.find('[data-sidebar-block__toggle="open"]');
    if ($toggleBtn) {
      window.PXUTheme.jsSidebar.closeSidebarBlock($toggleBtn);
    }
  }

});

$(document)
.on('shopify:block:load', function(e){



});

// Document ready
$(function() {
  var $jsSections = $('.shopify-section[class*=js]');

  // Loop through sections with js classes and load them in
  var $jsSectionNames = $jsSections.each(function () {
    for (var i = 0; i < this.classList.length; i++) {
      if (this.classList[i].substring(0, 2) === "js"){
        var triggerClass = this.classList[i];
        if (window.PXUTheme[triggerClass]) {
          // console.log('Section: ' + triggerClass + ' has been loaded.')
          window.PXUTheme[triggerClass].init($(this));
        } else {
          // console.warn('Uh oh, ' + triggerClass + ' is referenced in section schema class, but can not be found. Make sure "z__' + triggerClass + '.js" and window.PXUTheme.' + triggerClass + '.init() function exists.');
        }

      }
    }
  });

  var resizeTimer;

  // Store window width in variable
  var width = $(window).width(), height = $(window).height();

  $(window).on('resize', function(e) {

    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {

      window.PXUTheme.objectFitImages.calculateAspectRatio();

      if (window.PXUTheme.jsHeader.header_layout === 'vertical') {
        window.PXUTheme.predictiveSearch.alignVerticalSearch()
      }

      if (!isScreenSizeLarge()){
        // When 798 or less
        window.PXUTheme.mobileMenu.init();

      } else {

        // When larger than 798
        window.PXUTheme.mobileMenu.unload();
      }

    }, 250);

  });

  //Enable plyr
  window.PXUTheme.video.init();

  // Predictive search
  if (window.PXUTheme.theme_settings.enable_autocomplete == true) {
    window.PXUTheme.predictiveSearch.init();
  }

  window.PXUTheme.dropdownMenu();

  window.PXUTheme.disclosure.enable();

  // Scrolling animations
  window.PXUTheme.animation.init();

  // QuantityBox
  window.PXUTheme.quantityBox.init();

  /* Show associated variant image on hover */
  if (window.PXUTheme.theme_settings.show_collection_swatches == true) {
    window.PXUTheme.thumbnail.enableSwatches();
  }

  /* Show secondary image on hover */
  if (window.PXUTheme.theme_settings.show_secondary_image == true) {
    window.PXUTheme.thumbnail.showVariantImage();
  }

  // Quick shop
  if (window.PXUTheme.theme_settings.enable_quickshop) {
    window.PXUTheme.thumbnail.showQuickShop();
  }

  // Currency converter
  if (window.PXUTheme.currencyConverter) {
    window.PXUTheme.currencyConverter.init();
  }

  //Infinite scrolling
  if ($('[data-custom-pagination]').length) {
    window.PXUTheme.infiniteScroll.init();
  }

  //Select event for native multi currency checkout
  $('.shopify-currency-form select').on('change', function () {
    $(this)
      .parents('form')
      .submit();
  });

  // Tabs
  if($('.tabs').length > 0) {
    window.PXUTheme.tabs.enableTabs();
  }

  // Additional checkout buttons
  if (!isScreenSizeLarge()) {
    $('.additional-checkout-buttons').addClass('additional-checkout-buttons--vertical');
  }

  // Accordion
  if($('.accordion, [data-cc-accordion]').length > 0) {
    window.PXUTheme.contentCreator.accordion.init();
  }

  // Backwards compatiblity for Flexslider
  if($('.slider, .flexslider').length > 0) {
    window.PXUTheme.contentCreator.slideshow.init();
  }

  // Object Fit Images
  window.PXUTheme.objectFitImages.init();

  // Responsive Video
  window.PXUTheme.responsiveVideo.init();

  // Flickity IOS Fix
  window.PXUTheme.flickityIosFix();

  // Product review scroll
  window.PXUTheme.productReviews.productReviewScroll();

  if (window.PXUTheme.theme_settings.shipping_calculator_enabled && document.querySelector('[data-shipping-calculator]')) {
    const shippingCalculator = new ShippingCalculator({ el: document.querySelector('[data-shipping-calculator]') });
  }
});

/*============================================================================
Slideshow arrows
==============================================================================*/

if (window.PXUTheme.theme_settings.icon_style == 'icon_solid') {
  window.arrowShape = 'M95.04 46 21.68 46 48.18 22.8 42.91 16.78 4.96 50 42.91 83.22 48.18 77.2 21.68 54 95.04 54 95.04 46z';
} else {
  window.arrowShape = 'M95,48H9.83L41,16.86A2,2,0,0,0,38.14,14L3.59,48.58a1.79,1.79,0,0,0-.25.31,1.19,1.19,0,0,0-.09.15l-.1.2-.06.2a.84.84,0,0,0,0,.17,2,2,0,0,0,0,.78.84.84,0,0,0,0,.17l.06.2.1.2a1.19,1.19,0,0,0,.09.15,1.79,1.79,0,0,0,.25.31L38.14,86A2,2,0,0,0,41,86a2,2,0,0,0,0-2.83L9.83,52H95a2,2,0,0,0,0-4Z';
}

})();

/******/ })()
;

// include timeZoneCityToCountry via script, require, or import 
let timeZoneCityToCountry = {
 "Andorra": "Andorra",
 "Dubai": "United Arab Emirates",
 "Kabul": "Afghanistan",
 "Tirane": "Albania",
 "Yerevan": "Armenia",
 "Casey": "Antarctica",
 "Davis": "Antarctica",
 "Mawson": "Antarctica",
 "Palmer": "Antarctica",
 "Rothera": "Antarctica",
 "Troll": "Antarctica",
 "Vostok": "Antarctica",
 "Buenos_Aires": "Argentina",
 "Cordoba": "Argentina",
 "Salta": "Argentina",
 "Jujuy": "Argentina",
 "Tucuman": "Argentina",
 "Catamarca": "Argentina",
 "La_Rioja": "Argentina",
 "San_Juan": "Argentina",
 "Mendoza": "Argentina",
 "San_Luis": "Argentina",
 "Rio_Gallegos": "Argentina",
 "Ushuaia": "Argentina",
 "Pago_Pago": "Samoa (American)",
 "Vienna": "Austria",
 "Lord_Howe": "Australia",
 "Macquarie": "Australia",
 "Hobart": "Australia",
 "Melbourne": "Australia",
 "Sydney": "Australia",
 "Broken_Hill": "Australia",
 "Brisbane": "Australia",
 "Lindeman": "Australia",
 "Adelaide": "Australia",
 "Darwin": "Australia",
 "Perth": "Australia",
 "Eucla": "Australia",
 "Baku": "Azerbaijan",
 "Barbados": "Barbados",
 "Dhaka": "Bangladesh",
 "Brussels": "Belgium",
 "Sofia": "Bulgaria",
 "Bermuda": "Bermuda",
 "Brunei": "Brunei",
 "La_Paz": "Bolivia",
 "Noronha": "Brazil",
 "Belem": "Brazil",
 "Fortaleza": "Brazil",
 "Recife": "Brazil",
 "Araguaina": "Brazil",
 "Maceio": "Brazil",
 "Bahia": "Brazil",
 "Sao_Paulo": "Brazil",
 "Campo_Grande": "Brazil",
 "Cuiaba": "Brazil",
 "Santarem": "Brazil",
 "Porto_Velho": "Brazil",
 "Boa_Vista": "Brazil",
 "Manaus": "Brazil",
 "Eirunepe": "Brazil",
 "Rio_Branco": "Brazil",
 "Thimphu": "Bhutan",
 "Minsk": "Belarus",
 "Belize": "Belize",
 "St_Johns": "Canada",
 "Halifax": "Canada",
 "Glace_Bay": "Canada",
 "Moncton": "Canada",
 "Goose_Bay": "Canada",
 "Toronto": "Canada",
 "Nipigon": "Canada",
 "Thunder_Bay": "Canada",
 "Iqaluit": "Canada",
 "Pangnirtung": "Canada",
 "Winnipeg": "Canada",
 "Rainy_River": "Canada",
 "Resolute": "Canada",
 "Rankin_Inlet": "Canada",
 "Regina": "Canada",
 "Swift_Current": "Canada",
 "Edmonton": "Canada",
 "Cambridge_Bay": "Canada",
 "Yellowknife": "Canada",
 "Inuvik": "Canada",
 "Dawson_Creek": "Canada",
 "Fort_Nelson": "Canada",
 "Whitehorse": "Canada",
 "Dawson": "Canada",
 "Vancouver": "Canada",
 "Cocos": "Cocos (Keeling) Islands",
 "Zurich": "Switzerland",
 "Abidjan": "Côte d'Ivoire",
 "Rarotonga": "Cook Islands",
 "Santiago": "Chile",
 "Punta_Arenas": "Chile",
 "Easter": "Chile",
 "Shanghai": "China",
 "Urumqi": "China",
 "Bogota": "Colombia",
 "Costa_Rica": "Costa Rica",
 "Havana": "Cuba",
 "Cape_Verde": "Cape Verde",
 "Christmas": "Christmas Island",
 "Nicosia": "Cyprus",
 "Famagusta": "Cyprus",
 "Prague": "Czech Republic",
 "Berlin": "Germany",
 "Copenhagen": "Denmark",
 "Santo_Domingo": "Dominican Republic",
 "Algiers": "Algeria",
 "Guayaquil": "Ecuador",
 "Galapagos": "Ecuador",
 "Tallinn": "Estonia",
 "Cairo": "Egypt",
 "El_Aaiun": "Western Sahara",
 "Madrid": "Spain",
 "Ceuta": "Spain",
 "Canary": "Spain",
 "Helsinki": "Finland",
 "Fiji": "Fiji",
 "Stanley": "Falkland Islands",
 "Chuuk": "Micronesia",
 "Pohnpei": "Micronesia",
 "Kosrae": "Micronesia",
 "Faroe": "Faroe Islands",
 "Paris": "France",
 "London": "Britain (UK)",
 "Tbilisi": "Georgia",
 "Cayenne": "French Guiana",
 "Gibraltar": "Gibraltar",
 "Nuuk": "Greenland",
 "Danmarkshavn": "Greenland",
 "Scoresbysund": "Greenland",
 "Thule": "Greenland",
 "Athens": "Greece",
 "South_Georgia": "South Georgia & the South Sandwich Islands",
 "Guatemala": "Guatemala",
 "Guam": "Guam",
 "Bissau": "Guinea-Bissau",
 "Guyana": "Guyana",
 "Hong_Kong": "Hong Kong",
 "Tegucigalpa": "Honduras",
 "Port-au-Prince": "Haiti",
 "Budapest": "Hungary",
 "Jakarta": "Indonesia",
 "Pontianak": "Indonesia",
 "Makassar": "Indonesia",
 "Jayapura": "Indonesia",
 "Dublin": "Ireland",
 "Jerusalem": "Israel",
 "Kolkata": "India",
 "Calcutta": "India",
 "Chagos": "British Indian Ocean Territory",
 "Baghdad": "Iraq",
 "Tehran": "Iran",
 "Reykjavik": "Iceland",
 "Rome": "Italy",
 "Jamaica": "Jamaica",
 "Amman": "Jordan",
 "Tokyo": "Japan",
 "Nairobi": "Kenya",
 "Bishkek": "Kyrgyzstan",
 "Tarawa": "Kiribati",
 "Kanton": "Kiribati",
 "Kiritimati": "Kiribati",
 "Pyongyang": "Korea (North)",
 "Seoul": "Korea (South)",
 "Almaty": "Kazakhstan",
 "Qyzylorda": "Kazakhstan",
 "Qostanay": "Kazakhstan",
 "Aqtobe": "Kazakhstan",
 "Aqtau": "Kazakhstan",
 "Atyrau": "Kazakhstan",
 "Oral": "Kazakhstan",
 "Beirut": "Lebanon",
 "Colombo": "Sri Lanka",
 "Monrovia": "Liberia",
 "Vilnius": "Lithuania",
 "Luxembourg": "Luxembourg",
 "Riga": "Latvia",
 "Tripoli": "Libya",
 "Casablanca": "Morocco",
 "Monaco": "Monaco",
 "Chisinau": "Moldova",
 "Majuro": "Marshall Islands",
 "Kwajalein": "Marshall Islands",
 "Yangon": "Myanmar (Burma)",
 "Ulaanbaatar": "Mongolia",
 "Hovd": "Mongolia",
 "Choibalsan": "Mongolia",
 "Macau": "Macau",
 "Martinique": "Martinique",
 "Malta": "Malta",
 "Mauritius": "Mauritius",
 "Maldives": "Maldives",
 "Mexico_City": "Mexico",
 "Cancun": "Mexico",
 "Merida": "Mexico",
 "Monterrey": "Mexico",
 "Matamoros": "Mexico",
 "Mazatlan": "Mexico",
 "Chihuahua": "Mexico",
 "Ojinaga": "Mexico",
 "Hermosillo": "Mexico",
 "Tijuana": "Mexico",
 "Bahia_Banderas": "Mexico",
 "Kuala_Lumpur": "Malaysia",
 "Kuching": "Malaysia",
 "Maputo": "Mozambique",
 "Windhoek": "Namibia",
 "Noumea": "New Caledonia",
 "Norfolk": "Norfolk Island",
 "Lagos": "Nigeria",
 "Managua": "Nicaragua",
 "Amsterdam": "Netherlands",
 "Oslo": "Norway",
 "Kathmandu": "Nepal",
 "Nauru": "Nauru",
 "Niue": "Niue",
 "Auckland": "New Zealand",
 "Chatham": "New Zealand",
 "Panama": "Panama",
 "Lima": "Peru",
 "Tahiti": "French Polynesia",
 "Marquesas": "French Polynesia",
 "Gambier": "French Polynesia",
 "Port_Moresby": "Papua New Guinea",
 "Bougainville": "Papua New Guinea",
 "Manila": "Philippines",
 "Karachi": "Pakistan",
 "Warsaw": "Poland",
 "Miquelon": "St Pierre & Miquelon",
 "Pitcairn": "Pitcairn",
 "Puerto_Rico": "Puerto Rico",
 "Gaza": "Palestine",
 "Hebron": "Palestine",
 "Lisbon": "Portugal",
 "Madeira": "Portugal",
 "Azores": "Portugal",
 "Palau": "Palau",
 "Asuncion": "Paraguay",
 "Qatar": "Qatar",
 "Reunion": "Réunion",
 "Bucharest": "Romania",
 "Belgrade": "Serbia",
 "Kaliningrad": "Russia",
 "Moscow": "Russia",
 "Simferopol": "Russia",
 "Kirov": "Russia",
 "Volgograd": "Russia",
 "Astrakhan": "Russia",
 "Saratov": "Russia",
 "Ulyanovsk": "Russia",
 "Samara": "Russia",
 "Yekaterinburg": "Russia",
 "Omsk": "Russia",
 "Novosibirsk": "Russia",
 "Barnaul": "Russia",
 "Tomsk": "Russia",
 "Novokuznetsk": "Russia",
 "Krasnoyarsk": "Russia",
 "Irkutsk": "Russia",
 "Chita": "Russia",
 "Yakutsk": "Russia",
 "Khandyga": "Russia",
 "Vladivostok": "Russia",
 "Ust-Nera": "Russia",
 "Magadan": "Russia",
 "Sakhalin": "Russia",
 "Srednekolymsk": "Russia",
 "Kamchatka": "Russia",
 "Anadyr": "Russia",
 "Riyadh": "Saudi Arabia",
 "Guadalcanal": "Solomon Islands",
 "Mahe": "Seychelles",
 "Khartoum": "Sudan",
 "Stockholm": "Sweden",
 "Singapore": "Singapore",
 "Paramaribo": "Suriname",
 "Juba": "South Sudan",
 "Sao_Tome": "Sao Tome & Principe",
 "El_Salvador": "El Salvador",
 "Damascus": "Syria",
 "Grand_Turk": "Turks & Caicos Is",
 "Ndjamena": "Chad",
 "Kerguelen": "French Southern & Antarctic Lands",
 "Bangkok": "Thailand",
 "Dushanbe": "Tajikistan",
 "Fakaofo": "Tokelau",
 "Dili": "East Timor",
 "Ashgabat": "Turkmenistan",
 "Tunis": "Tunisia",
 "Tongatapu": "Tonga",
 "Istanbul": "Turkey",
 "Funafuti": "Tuvalu",
 "Taipei": "Taiwan",
 "Kiev": "Ukraine",
 "Uzhgorod": "Ukraine",
 "Zaporozhye": "Ukraine",
 "Wake": "US minor outlying islands",
 "New_York": "United States",
 "Detroit": "United States",
 "Louisville": "United States",
 "Monticello": "United States",
 "Indianapolis": "United States",
 "Vincennes": "United States",
 "Winamac": "United States",
 "Marengo": "United States",
 "Petersburg": "United States",
 "Vevay": "United States",
 "Chicago": "United States",
 "Tell_City": "United States",
 "Knox": "United States",
 "Menominee": "United States",
 "Center": "United States",
 "New_Salem": "United States",
 "Beulah": "United States",
 "Denver": "United States",
 "Boise": "United States",
 "Phoenix": "United States",
 "Los_Angeles": "United States",
 "Anchorage": "United States",
 "Juneau": "United States",
 "Sitka": "United States",
 "Metlakatla": "United States",
 "Yakutat": "United States",
 "Nome": "United States",
 "Adak": "United States",
 "Honolulu": "United States",
 "Montevideo": "Uruguay",
 "Samarkand": "Uzbekistan",
 "Tashkent": "Uzbekistan",
 "Caracas": "Venezuela",
 "Ho_Chi_Minh": "Vietnam",
 "Efate": "Vanuatu",
 "Wallis": "Wallis & Futuna",
 "Apia": "Samoa (western)",
 "Johannesburg": "South Africa",
 "Antigua": "Antigua & Barbuda",
 "Anguilla": "Anguilla",
 "Luanda": "Angola",
 "McMurdo": "Antarctica",
 "DumontDUrville": "Antarctica",
 "Syowa": "Antarctica",
 "Aruba": "Aruba",
 "Mariehamn": "Åland Islands",
 "Sarajevo": "Bosnia & Herzegovina",
 "Ouagadougou": "Burkina Faso",
 "Bahrain": "Bahrain",
 "Bujumbura": "Burundi",
 "Porto-Novo": "Benin",
 "St_Barthelemy": "St Barthelemy",
 "Kralendijk": "Caribbean NL",
 "Nassau": "Bahamas",
 "Gaborone": "Botswana",
 "Blanc-Sablon": "Canada",
 "Atikokan": "Canada",
 "Creston": "Canada",
 "Kinshasa": "Congo (Dem. Rep.)",
 "Lubumbashi": "Congo (Dem. Rep.)",
 "Bangui": "Central African Rep.",
 "Brazzaville": "Congo (Rep.)",
 "Douala": "Cameroon",
 "Curacao": "Curaçao",
 "Busingen": "Germany",
 "Djibouti": "Djibouti",
 "Dominica": "Dominica",
 "Asmara": "Eritrea",
 "Addis_Ababa": "Ethiopia",
 "Libreville": "Gabon",
 "Grenada": "Grenada",
 "Guernsey": "Guernsey",
 "Accra": "Ghana",
 "Banjul": "Gambia",
 "Conakry": "Guinea",
 "Guadeloupe": "Guadeloupe",
 "Malabo": "Equatorial Guinea",
 "Zagreb": "Croatia",
 "Isle_of_Man": "Isle of Man",
 "Jersey": "Jersey",
 "Phnom_Penh": "Cambodia",
 "Comoro": "Comoros",
 "St_Kitts": "St Kitts & Nevis",
 "Kuwait": "Kuwait",
 "Cayman": "Cayman Islands",
 "Vientiane": "Laos",
 "St_Lucia": "St Lucia",
 "Vaduz": "Liechtenstein",
 "Maseru": "Lesotho",
 "Podgorica": "Montenegro",
 "Marigot": "St Martin (French)",
 "Antananarivo": "Madagascar",
 "Skopje": "North Macedonia",
 "Bamako": "Mali",
 "Saipan": "Northern Mariana Islands",
 "Nouakchott": "Mauritania",
 "Montserrat": "Montserrat",
 "Blantyre": "Malawi",
 "Niamey": "Niger",
 "Muscat": "Oman",
 "Kigali": "Rwanda",
 "St_Helena": "St Helena",
 "Ljubljana": "Slovenia",
 "Longyearbyen": "Svalbard & Jan Mayen",
 "Bratislava": "Slovakia",
 "Freetown": "Sierra Leone",
 "San_Marino": "San Marino",
 "Dakar": "Senegal",
 "Mogadishu": "Somalia",
 "Lower_Princes": "St Maarten (Dutch)",
 "Mbabane": "Eswatini (Swaziland)",
 "Lome": "Togo",
 "Port_of_Spain": "Trinidad & Tobago",
 "Dar_es_Salaam": "Tanzania",
 "Kampala": "Uganda",
 "Midway": "US minor outlying islands",
 "Vatican": "Vatican City",
 "St_Vincent": "St Vincent",
 "Tortola": "Virgin Islands (UK)",
 "St_Thomas": "Virgin Islands (US)",
 "Aden": "Yemen",
 "Mayotte": "Mayotte",
 "Lusaka": "Zambia",
 "Harare": "Zimbabwe"
};

let userRegion;
let userCity;
let userCountry;
let userTimeZone;

if (Intl) {
  userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  let tzArr = userTimeZone.split("/");
  userRegion = tzArr[0];
  userCity = tzArr[tzArr.length - 1];
  userCountry = timeZoneCityToCountry[userCity];
}
console.log("Country:", userCountry);

const countryModal = document.querySelector('.country-modal');

if (countryModal) {
  if (userCountry != 'Switzerland') {
   const checkCookie = document.cookie.indexOf("countrySelect");

     if(checkCookie > 0 ){
      countryModal.classList.remove('visible');
      document.body.classList.remove('country-modal-hidden')
    } else {
      createCookie();
      countryModal.classList.add('visible');
      document.body.classList.add('country-modal-hidden')
    }
  }
}

// get current date
function getDate(numOfMonths, date = new Date()) {
  date.setMonth(date.getMonth() + numOfMonths);
  return date;
}
// create cookie
function createCookie() { 
  const date = new Date();
  date.setTime(getDate(2));
  document.cookie = 'mollerus=countrySelect;expires='+date.toUTCString()+';path=/';
}

  equalHeights = function(container){
  var currentTallest = 0,
    currentRowStart = 0,
    rowDivs = new Array(),
    $el,
    topPosition = 0;
   jQuery(container).each(function() {
    $el = jQuery(this);
    jQuery($el).height('auto')
    topPostion = $el.position().top;
     if (currentRowStart != topPostion) {
        for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
          rowDivs[currentDiv].height(currentTallest);
        }
      rowDivs.length = 0; // empty the array
      currentRowStart = topPostion;
      currentTallest = $el.height();
      rowDivs.push($el);
     } else {
      rowDivs.push($el);
      currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);
    }
     for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
       rowDivs[currentDiv].height(currentTallest);
     }
   });
  }
  $(document).ready(function() {
    
      var annoucementHeight = $('.announcement-sticky-wrapper').height();
      if($(window).width() < 769){
      $('.mainHedaerClassic').css('top',annoucementHeight+ 'px')
      }
equalHeights('.review-widget .main_customer_review')
  });
  jQuery(window).resize(function(){
equalHeights('.review-widget .main_customer_review')
  });
  $('body').on('mouseover','.country-btn',function(){
    $(this).addClass('is-clicked')
  })
  $('body').on('mouseleave','.country-btn',function(){
    $(this).removeClass('is-clicked')
  })
  $('body').on('mouseover','.country_opt',function(){
    $(this).siblings('.country-btn').addClass('is-clicked')
  })
  $('body').on('mouseleave','.country_opt',function(){
    $(this).siblings('.country-btn').removeClass('is-clicked')
  })

//countdown

// (function () {
//   const second = 1000,
//         minute = second * 60,
//         hour = minute * 60,
//         day = hour * 24;

//   const countdownDiv = document.getElementById("countdown");
//   if (!countdownDiv) return; 

//   const days = countdownDiv.getAttribute("days");
//   const hours = countdownDiv.getAttribute("hours");
//   const minutes = countdownDiv.getAttribute("minutes");

//   if (!days || !hours || !minutes) return; 

//   let today = new Date(),
//       dd = String(today.getDate()).padStart(2, "0"),
//       mm = String(today.getMonth() + 1).padStart(2, "0"),
//       yyyy = today.getFullYear(),
//       nextYear = yyyy + 1,
//       dayMonth = `${days}`,
//       finalDate = dayMonth + yyyy;

//   today = mm + "/" + dd + "/" + yyyy;

//   if (today > finalDate) {
//     finalDate = dayMonth + nextYear;
//   }

//   const targetHour = hours;  
//   const targetMinute = minutes;

//   const targetDateStr = finalDate + " " + targetHour + ":" + targetMinute + ":00";
//   const targetDate = new Date(targetDateStr + " UTC");

//   const offsetZurich = (new Date().toLocaleString('en-US', {timeZone: 'Europe/Zurich'}).includes('AM') ? 1 : 2);
//   targetDate.setHours(targetDate.getHours() + offsetZurich);

//   const countDown = targetDate.getTime();

//   const x = setInterval(function() {
//     const now = new Date().getTime(),
//           distance = countDown - now;

//     document.getElementById("days").innerText = Math.floor(distance / (day));
//     document.getElementById("hours").innerText = Math.floor((distance % (day)) / (hour));
//     document.getElementById("minutes").innerText = Math.floor((distance % (hour)) / (minute));
//     document.getElementById("seconds").innerText = Math.floor((distance % (minute)) / second);

//     if (distance < 0) {
//       document.getElementById("countdown").style.display = "none";
//       document.getElementById("content").style.display = "block";
//       clearInterval(x);
//     }
//   }, 1000); 
// }());
 $(document).ready(function() {
var countDownDate = new Date(window.countdown_timer).getTime();
// Update the count down every 1 second
var x = setInterval(function() {
  // Get the current time in UTC and adjust to Eastern Time
  // var now = new Date();
  var now = new Date().getTime();
  var easternDate = new Date(now.toLocaleString("en-US", { timeZone: "America/New_York" }));
  var easternTimestamp = easternDate.getTime();

  // Find the distance between now and the countdown date
  // var distance = countDownDate - easternTimestamp;
   var distance = countDownDate - now;
    
  // Time calculations for days, hours, minutes, and seconds
  var days = Math.floor(distance / (1000 * 60 * 60 * 24));
  var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
  var seconds = Math.floor((distance % (1000 * 60)) / 1000);
    
  // Update the timer display
  if (document.getElementById("timer_div")) {
    var dayEl = document.getElementById("days"),
      hourEl = document.getElementById("hours"),
      minuteEl = document.getElementById("minutes"),
      secondEl = document.getElementById("seconds");
    if (distance > 0) {
      dayEl.innerHTML = days;
      hourEl.innerHTML = hours;
      minuteEl.innerHTML = minutes
      secondEl.innerHTML = seconds;
      // document.getElementById("timer_div").innerHTML = `<li><span id="days">${days}</span>Days</li> : ${hours}H : ${minutes}M : ${seconds}`;
    } else {
      // Display custom message when countdown reaches zero
      document.getElementById("timer_div").innerHTML = ''
       document.getElementById("content").style.display = 'block';
     }   
  }
  // If the countdown is over, clear the interval and adjust body classes
  if (distance <= 0) {
    clearInterval(x);
  }
}, 1000);
 })

 function spotted_slider() {
  var spotted_info = $(".spotted-info");
  var options = {
    pageDots: false,
    wrapAround: true,
    groupCells: 3,
    contain: true,
    cellAlign: "center",
    lazyLoad: true,
    draggable: true,
    dragThreshold: 3,
  };
  if ($(window).width() <= 798) {
    if (spotted_info.hasClass("flickity-enabled")) {
      spotted_info.flickity("destroy");
    }
    spotted_info.flickity({
      pageDots: false,
      cellAlign: "center",
      wrapAround: true,
      groupCells: 1,
      contain: true,
      lazyLoad: true,
      draggable: true,
    });
  } else {
    if (spotted_info.hasClass("flickity-enabled")) {
      spotted_info.flickity("destroy");
    }
    spotted_info.flickity(options);
  }
}

spotted_slider();